import $ from "jquery";
import Globalize from "globalize/lib/globalize.js";

import "./js/js-compat.js";
import "../node_modules/@rwap/jquery-ui-touch-punch/jquery.ui.touch-punch.js";
import "./js/jquery-qstring.js";
import "./js/jquery-cookie.js";
import "./js/jquery-popup.js";
import "./js/jquery-sticky.js";
import "./js/jquery-toolaction.js";
import "./js/jquery-highlight.js";
import "./js/jquery-quicksearch.js";
import "./js/jquery-colorpicker.js";
import "./js/jquery-filepicker.js";
import "./js/jquery-theadscroll.js";
import "./js/jquery-inittz.js";
import "./js/jquery-komodel.js";
import { addScript, mq } from "./js/fs.js";
import { getCalendarOptions, getDatePickerOptions, overrideDatePicker } from "./js/fs-initdp.js";
import { initGrids } from "./js/fs-initgrids.js";
import * as Form from "./js/fs-form.js";

if(!("maxAllowedContentLength" in window))
	window.maxAllowedContentLength = 20480000;

const FS = {
	addScript,
	mq,
	getCalendarOptions,
	getDatePickerOptions,
	overrideDatePicker,
	initGrids,
	Form
};

// add here a code to execute when dom is loaded
$(function() {

	overrideDatePicker();

	// attach date pickers
	$("input.date").datepicker();

	// attach color pickers
	$("input.color").colorpicker();

	// attach file pickers
	$("input[type=\"file\"]").filepicker();

	// attach toolactions
	$("button.fs-toolaction").toolaction({ from: "@data-menu", appendMenuTo: "parent" });

	// select timezone value
	$("select[data-timezone]").initTZ();

	// build knockout model from form
	$(document.forms).komodel();

	Form.init();
});


export { FS, Globalize };